// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__2sbTU","full-screen":"loader_full-screen__1wWM1","loader-wrapper":"loader_loader-wrapper__clDvB"};